// Keyed by type NAME, not id: OrganizationalUnitType ids differ between environments.
export const ORG_UNIT_TYPE_COLORS: Record<string, string> = {
  Institución: '#437cd9',
  Categoría: '#8f420b',
  'Sub-Categoría': '#a0a0a0',
  Sector: '#1b803e',
  OCIF: '#6d28d9',
};

export function getOrgUnitTypeColor(typeName?: string | null): string {
  return (typeName && ORG_UNIT_TYPE_COLORS[typeName]) || '';
}

/** JSONata equivalent of getOrgUnitTypeColor over `$value`, for WorkTray badge columns. */
export const ORG_UNIT_TYPE_COLOR_EXPR = Object.entries(ORG_UNIT_TYPE_COLORS).reduceRight(
  (fallback, [name, color]) => `($value = '${name}' ? '${color}' : ${fallback})`,
  "''"
);
